<template>
    <div class="views-content">

        <banner-generic :data="data.hero" :class="addedClassZero"></banner-generic>

        <!-- elements -->
        <div v-for="(element, index) in data.elements" :key="element.id">
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>

    </div>
</template>

<script>
    import viewsElementClasses from '../mixins/viewsElementClasses';
    import { BannerGeneric} from "../components";
    import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours, ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";
    
    export default {
        name: "v-page",
        mixins: [viewsElementClasses],
        components: {
            BannerGeneric,
            ElementBackgroundImage,
            ElementAccordion,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage,
            ElementForm
        },
        props: {
            data: {
                type: Object
            }
        }
    };
</script>
